<template>
    <el-dialog
        :visible.sync="dialogVisible"
        title="批量设置运营结果"
        :close-on-press-escape="false"
        width="750px"
        append-to-body
        :before-close="handleClose">

        <div class="content">
            <div v-if="!Array.isArray(resData) && resData.length != 0">
                <p class="mb10">【{{resData.succ_num}}】个账户设置成功，【{{resData.err_num}}】个账户设置失败
                    <span v-if="resData.same_time.length>0||resData.same_user_time.length>0">，失败详情如下：</span>
                </p>

                <div class="ml12 mb10 font12px" v-if="resData.same_user_time.length>0">
                    <h4 class="group-title mb10">成员与日期重复（{{resData.same_user_time.length}}）：</h4>
                    <p>该成员在该时间已存在，账户：</p>
                    <p class="pl10" v-for="(item, index) in resData.same_user_time" :key="index">{{item.user_name}}</p>
                </div>

                <div class="ml12 font12px" v-if="resData.same_time.length>0">
                    <h4 class="group-title mb10">日期重复（{{resData.same_time.length}}）：</h4>
                    <p>该时间已存在负责人，确定要覆盖吗？账户：</p>
                    <p class="pl10" v-for="(item, index) in resData.same_time" :key="index">{{item.user_name}}</p>
                </div>
            </div>

            <div v-else>
                <p class="mb10">
                    {{info}}
                </p>
            </div>
            
        </div>

        <div slot="footer" class="dialog-footer tac" v-if="isShowCoverBtn">
            <el-button type="default" @click="handleClose" class="action-btn mr20">关闭</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20">覆盖</el-button>
        </div>
        <div slot="footer" class="dialog-footer tac" v-else>
            <el-button type="default" @click="handleClose" class="action-btn mr20">关闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import API from '@/api/mediaAccount.js';

    export default {
        name: "BatchYYResultModal",
        components:{

        },
        props:{
            code:{
                required:true,
                type:[String,Number],
            },
            resData:{
                required:true,
                type:Object,
            },
            info: {
                type: String
            }
        },
        data() {
            return {
                submitLoading:false,
                dialogVisible: false,
            }
        },
        computed: {
            isShowCoverBtn(){
                return (this.resData.same_time||[]).length>0;
            }
        },
        methods: {
            handleClose() {
                this.dialogVisible = false;
                this.submitLoading = false;
                this.$emit('close');
            },
            showModal() {
                this.dialogVisible = true;
            },
            hideModal(){
                this.dialogVisible = false;
                this.submitLoading = false;
            },
            endLoading(){
                this.submitLoading = false;
            },
            handleSubmit(){
                this.$emit('cover');
                this.submitLoading = true;
            },
        }
    }
</script>

<style scoped>
    .action-btn {
        width: 120px;
    }
</style>
